export default __webpack_public_path__ + "static/media/email-verification.9689a914.svg";